import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { getNounOverride } from "@whoosh/utilities/src/FormatNounOverride/getNounOverride";

import { useFacilityInstructorNoun_facility$key } from "./__generated__/useFacilityInstructorNoun_facility.graphql";

export const useFacilityInstructorNoun = (
  facilityRef: useFacilityInstructorNoun_facility$key | null,
  lowercaseFirstLetter?: boolean
) => {
  const facility = useFragment(
    useFacilityInstructorNounFragmentString,
    facilityRef
  );
  const copyOverrides = facility?.copyOverrides?.instructor;

  return {
    singular: getNounOverride(
      copyOverrides?.singular,
      t`instructor`,
      !!lowercaseFirstLetter
    ),
    plural: getNounOverride(
      copyOverrides?.plural,
      t`instructors`,
      !!lowercaseFirstLetter
    ),
  };
};

const useFacilityInstructorNounFragmentString = graphql`
  fragment useFacilityInstructorNoun_facility on Facility {
    copyOverrides {
      instructor {
        plural
        singular
      }
    }
  }
`;
